import { render } from "./DemographicTargetBlock.vue?vue&type=template&id=c79ffcb0"
import script from "./DemographicTargetBlock.vue?vue&type=script&lang=js"
export * from "./DemographicTargetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/DemographicTargetBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c79ffcb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c79ffcb0', __exports__)) {
    api.reload('c79ffcb0', __exports__)
  }
  
  module.hot.accept("./DemographicTargetBlock.vue?vue&type=template&id=c79ffcb0", () => {
    api.rerender('c79ffcb0', render)
  })

}


export default __exports__